import type { ReactNode } from 'react';

export const symbol_credit_card_clock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M720.36-35q-93.76 0-159.06-65T496-258q0-93 65.3-158.5T720.36-482Q813-482 878-416.47q65 65.53 65 158.5T878-100q-65 65-157.64 65ZM140-220v-320 20-220 520Zm0-411h680v-109H140v109Zm0 471q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v212q0 14-11.5 20t-23.5-1q-28.75-14.88-61.38-22.94Q751-540 716-540q-38 0-74 10t-67 28H140v282h284q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm591-100v-113q0-7.6-5.5-13.3Q720-392 712-392t-14 6q-6 6-6 14v114q0 5.57 2 10.78 2 5.22 6 10.22l84 86q6 6 14 6t14-6q6-6 6-14t-6-14l-81-81Z"
		/>
	</svg>
);
